<template>
  <div>
    <v-card>
      <v-container class="pt-0 pb-0">
        <v-layout>
          <v-btn small flat class="back-btn" @click="goBack">
            <v-icon>arrow_back</v-icon>
            <span>{{$t('feeds.feeds_breakdown_back')}}</span>
          </v-btn>
        </v-layout>
      </v-container>
    </v-card>

    <v-container pb-0>
      <h1 class="mb-2">{{role}}</h1>
      <custom-text :msg="customText" class="mt-2 mb-1"></custom-text>
      <div class="inline">

        <!-- left feed info card and filter panel -->
        <div class="filter-panel-outer hidden-sm-and-down" ref="filterPanelOuter">
          <v-layout column align-start align-content-start justify-start class="filter-panel-inner">
            <FeedRequestBreakdownInfoFilter/>
          </v-layout>
        </div>

        <div class="content-panel">
          <FeedFilteredTable id="feedBreakdownPageFilter">
            <v-layout column slot="page-heading">
              <h1 class="mb-2">{{$t('feeds.feed_breakdown_request_table')}}</h1>
            </v-layout>
            <div slot="header" key="main-content">
              <!--              <v-layout row class="hidden-xs-only" justify-end>-->
              <!--                <v-flex sm3 xs6 mt-2>-->
              <!--                  <v-btn-->
              <!--                    outline class="mr-0 students_download" color="primary">-->
              <!--                    <v-icon left>file_download</v-icon>-->
              <!--                    {{$t(report_download_button_label)}}-->
              <!--                  </v-btn>-->
              <!--                  {{$t('results', {count: totalElements}, totalElements)}}-->
              <!--                </v-flex>-->
              <!--              </v-layout>-- class="justify-start align-left align-content-start"> -->
              <v-layout mt-2 row>
                <v-flex xs2 class="body-2  ml-3">
                  {{$t('feeds.request_id')}}
                </v-flex>
                <v-flex xs2 class="hidden-xs-only body-2">
                  {{$t('feeds.request_start')}}
                </v-flex>
                <v-flex xs2 class="hidden-xs-only body-2">
                  {{$t('feeds.request_finish')}}
                </v-flex>
                <v-flex xs2 class="body-2">
                  {{$t('feeds.records_processed')}}
                </v-flex>
                <v-flex xs2 class="body-2">
                  {{$t('feeds.records_errored')}}
                </v-flex>
              </v-layout>
              <v-progress-linear v-if="loading" height="2" :indeterminate="true" color="accent"></v-progress-linear>
            </div>
            <FeedRequestBreakdownInfoRow slot="table"></FeedRequestBreakdownInfoRow>
          </FeedFilteredTable>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import DateFormat from '../../mixins/DateFormat'
  import FeedRequestBreakdownInfoFilter from './FeedRequestBreakdownInfoFilter'
  import FeedRequestBreakdownInfoRow from './FeedRequestBreakdownInfoRow'
  import FeedRequestBreakdownInfoCard from './FeedRequestBreakdownInfoCard'
  import FeedFilteredTable from '../FeedFilteredTable'
  import CustomText from '../help/CustomText'
  import Roles from '../../mixins/Roles'
  import moment from 'moment-es6'
  import {mapState} from 'vuex'
  import {LOAD_FEED_SCHEDULE_ID, LOAD_FEED_CARD_DATA, GET_FEED_BREAKDOWN_INFO} from '../../store/action-types'

  export default {
    name: 'feed-request-breakdown-info',
    mixins: [Roles, DateFormat],
    data () {
      return {
        now: moment().format('YYYY-MM-DD'),
        today: moment().format('YYYY-MM-DD'),
        role: '' | 'Role not assigned'
      }
    },
    computed: {
      ...mapState({
        showNoResult: state => state.feeds.isLoading || state.feeds.breakdownInfos.length === 0,
        loading: state => state.feeds.isLoading,
        totalElements: state => state.feeds.totalElements
      }),
      customText () {
        let role = this.isAdmin ? 'admin' : (this.isStaff ? 'staff' : 'student')
        this.role = role
        return 'custom-text.' + role + '_feeds_breakdown_info'
      },
      scheduleId () {
        return this.$route.params.id
      }
    },
    methods: {
      goBack () {
        this.$router.push({name: 'DailyFeeds'})
      }
    },
    mounted () {
      this.$store.dispatch(LOAD_FEED_SCHEDULE_ID, this.scheduleId)
      this.$store.dispatch(GET_FEED_BREAKDOWN_INFO)
      this.$store.dispatch(LOAD_FEED_CARD_DATA, this.scheduleId)
    },
    components: {
      FeedRequestBreakdownInfoFilter,
      FeedRequestBreakdownInfoRow,
      CustomText,
      FeedRequestBreakdownInfoCard,
      FeedFilteredTable
    }
  }
</script>

<style scoped>

  .inline {
    display: flex;
  }

  .content-panel {
    flex: 10 10 0;
  }

  .filter-panel-outer {
    flex: 3 3 0;
  }

  .filter-panel-inner {
    position: -webkit-sticky;
    position: sticky;
    top: 64px;
    padding: 8px 8px 0px 0px;
  }


  .table-padding {
    padding-left: 24px;
    padding-right: 48px;
  }

  .back-btn {
    text-transform: none;
    margin-left: 0px;
    font-size: 14px;
  }

  .btn.back-btn > > > .btn__content {
    padding-left: 0px;
  }

  button.link.btn {
    text-decoration: underline;
    text-transform: none;
  }


</style>



// WEBPACK FOOTER //
// src/components/monitor/FeedRequestBreakdownInfo.vue